export const INTRO = '/';
export const HOME = '/home';

export const FACTORY = '/factory1';
export const FACTORY_HISTORY = '/factory1/history';
export const FACTORY_PRESENT = '/factory1/present';
export const FACTORY_PROCESS = '/factory1/process';
export const FACTORY_CITY = '/factory1/city';

export const FACTORY2 = '/factory';
export const FACTORY2_DEV = '/factory/dev';
export const FACTORY2_PROD = '/factory/about';
export const FACTORY2_BUILDING = '/factory/building';
export const FACTORY2_TRIALS = '/factory/trials';
export const FACTORY2_WARRANTY = '/factory/warranty';

// export const CENTER = '/center';
// export const CENTER_ABOUT = '/center/about';
// export const CENTER_SPEC = '/center/specialization';
// export const CENTER_ACCR = '/center/accreditation';

// export const CLUSTER = '/cluster';
// export const CLUSTER_ABOUT = '/cluster/about';
// export const CLUSTER_CONS = '/cluster/consumer';
// export const CLUSTER_EXPORT = '/cluster/export';

// export const PARK = '/technopark';
// export const PARK_ABOUT = '/technopark/about';
// export const PARK_INFR = '/technopark/infrastructure';
// export const PARK_PROD = '/technopark/products';

export const PROD = '/products';
export const PROD_110 = '/products/110kv';
export const PROD_220 = '/products/220kv';
export const PROD_330 = '/products/330kv';

export const PODST = '/podstantsii';
export const PODST_110 = '/podstantsii/110kv';
export const PODST_110_1 = '/podstantsii/110kv/1';
export const PODST_110_2 = '/podstantsii/110kv/2';
export const PODST_110_3 = '/podstantsii/110kv/3';
export const PODST_110_4 = '/podstantsii/110kv/4';
export const PODST_220 = '/podstantsii/220kv';
export const PODST_330 = '/podstantsii/330kv';
export const PODST_330_1 = '/podstantsii/330kv/1';
export const PODST_330_2 = '/podstantsii/330kv/2';
export const PODST_330_3 = '/podstantsii/330kv/3';
export const PODST_330_4 = '/podstantsii/330kv/4';

export const KOOPER = '/kooperatsiya';
export const KOOPER_CLUSTER = '/kooperatsiya/cluster';
export const KOOPER_PARK = '/kooperatsiya/park';
export const KOOPER_CENTER = '/kooperatsiya/center';

// export const TEMP = '/temp';

export const PROJECT = '/project';
// export const PROJECT_LOCATION = '/project/location';
// export const PROJECT_LOCATION = '/project/location/:id';
export const PROJECT_LOCATION_1 = '/project/location/1';
export const PROJECT_LOCATION_2 = '/project/location/2';
export const PROJECT_LOCATION_3 = '/project/location/3';
export const PROJECT_LOCATION_4 = '/project/location/4';
